import Layout from "../../components/Layout/Layout";

const EMAIL = "forteana@earthboundmartian.com";

const Contact = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          Forteana
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">Contact</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Date corrections, access notes, and “this hunt or gathering should be
          on the map” messages are welcome. Write to{" "}
          <a
            href={`mailto:${EMAIL}`}
            className="text-turquoise hover:text-mars break-all"
          >
            {EMAIL}
          </a>
          .
        </p>
        <p className="leading-relaxed mt-6">
          v1 has no user accounts. If you know a ghost hunt, haunted stay,
          cryptid festival, or UFO weekend worth planning a trip around —
          especially one you can actually camp near — tell us what the overnight
          situation actually is.
        </p>
        <a
          href={`mailto:${EMAIL}`}
          className="inline-block mt-10 bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Email Forteana
        </a>
      </section>
    </Layout>
  );
};

export default Contact;
